import { lazy, Suspense } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftCardLanding = lazy(
  () => import(/* webpackChunkName: 'GiftCardLanding' */ './Landing'),
);

export default function GiftCardLanding({
  match,
}: RouteComponentProps<{ occasion?: string }>) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftCardLanding occasion={match.params.occasion} />
    </Suspense>
  );
}
